<template>
  <div>
    <h3 class="heading">Additional Information</h3>
    <div v-for="(info, i) in additionalInformationProp" :key="i">
      <div class="prose" v-html="info.content"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['additionalInformationProp'],
    data() {
      return {};
    }
  }
</script>

<style lang="scss" scoped>
  .heading {
		font-size: 16px;
		line-height: 1.2;
		margin: 3rem 0 0.625rem 0;
	}

  .prose {
    margin-bottom: 1.25rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
</style>